import { render } from "./CredentialsSkeleton.vue.js?vue&type=template&id=46d8057e&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CredentialsSkeleton.vue?vue&type=template&id=46d8057e&scoped=true"
const script = {}

import "./CredentialsSkeleton.vue.scss?vue&type=style&index=0&id=46d8057e&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CredentialsSkeleton.vue?vue&type=style&index=0&id=46d8057e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d8057e"]])

export default __exports__